import { render } from "./UsuariosPage.vue?vue&type=template&id=241e53fb&scoped=true"
import script from "./UsuariosPage.vue?vue&type=script&lang=js"
export * from "./UsuariosPage.vue?vue&type=script&lang=js"

import "./UsuariosPage.vue?vue&type=style&index=0&id=241e53fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241e53fb"]])

export default __exports__